export default {
    dataApi: "https://api.checklistbank.org/"
}